import { render, staticRenderFns } from "./_coursesFeatured.vue?vue&type=template&id=869b6216"
import script from "./_coursesFeatured.vue?vue&type=script&lang=js"
export * from "./_coursesFeatured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports